<template>
  <div class="filter-header-cpn">
    <div class="left-area">
      <div class="plat-select-area">
        <span>平台: </span>
        <el-select size="mini"
                   v-model="plat"
                   @change="changePlat"
                   :disabled="!!fxUrlId">
          <el-option v-for="item in platOptions"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value"></el-option>
        </el-select>
      </div>
      <div class="cat-select-area"
           v-if="showCatTree">
        <span style="min-width:35px">类目: </span>
        <CatTree ref="CatTree"
                 :plat="plat"
                 :checkedKeys="defaultCheckedKeys"
                 :multiple="true"
                 v-model="selectIds"
                 :treeDomId="'catSheetTree'"
                 :treeDomSearchId="'catSheetTreeSearchId'"
                 :width="200"
                 :height="300"></CatTree>
      </div>
      <!-- 店铺分析筛选条件 -->
      <div class="tag"
           v-if="shopName.length !== 0">
        <span class="placehold">></span>
        <el-tag closable
                class="tagName"
                @close="handleShopClose">
          店铺:{{html2Text(shopName)}}
        </el-tag>
      </div>
      <!-- 品牌分析筛选条件 -->
      <div class="tag"
           v-if="brandName">
        <span class="placehold">></span>
        <el-tag closable
                class="tagName"
                @close="handleBrandClose">
          品牌:{{html2Text(brandName)}}
        </el-tag>
      </div>
      <!-- 商品分析筛选条件 -->
      <div class="tag"
           v-if="itemName.length !== 0">
        <span class="placehold">></span>
        <el-tag closable
                class="tagName"
                :title="html2Text(itemName)"
                @close="handleItemClose"
                v-if="itemName.length == 1">
          商品:{{html2Text(itemName)}}
        </el-tag>
        <el-tag closable
                class="tagName"
                :title="html2Text(itemName)"
                @close="handleItemClose"
                v-if="itemName.length > 1">
          商品: 已选择{{itemName.length}}个商品
        </el-tag>
      </div>
      <!-- SKU分析筛选条件 -->
      <div class="tag"
           v-if="skuName.length !== 0">
        <span class="placehold">></span>
        <el-tag closable
                class="tagName"
                @close="handleSkuClose">
          SKU：{{html2Text(skuName)}}
        </el-tag>
      </div>
      <!-- 属性分析筛选条件 -->
      <div class="aspect-tag"
           v-for="item in attrlist"
           :key="item.index + item.attrName">
        <span class="placehold">&gt;</span>
        <el-tag closable
                :key="item.index"
                @close="handleAttrListClose(item)"
                class="aspectName">
          <template>
            <span>{{transformAttrName(item.attrName) + ':' + html2Text(item.attrId)}}</span>
          </template>
        </el-tag>
      </div>
      <!-- 商品搜索筛选条件 -->
      <template v-if="titlelist.length > 0">
        <div class="tag"
             v-for="item in titlelist"
             :key="item.index">
          <span class="placehold">&gt;</span>
          <el-tag closable
                  class="tagName"
                  :key="item.index"
                  @close="handleTitleClose(item)">
            商品: "{{item.word}}"
          </el-tag>
        </div>
      </template>

      <!-- 评论搜索筛选条件 -->
      <div class="tag"
           v-if="contentWord">
        <span class="placehold">></span>
        <el-tag closable
                class="tagName"
                @close="handleContentClose">
          评论: "{{contentWord}}"
        </el-tag>
      </div>
      <!-- 价格搜索筛选条件 -->
      <div class="tag"
           v-if="priceMax || priceMin">
        <span class="placehold">></span>
        <el-tag closable
                class="tagName"
                @close="handlePriceClose">
          价格: {{priceInteval}}
        </el-tag>
      </div>
      <!-- 商品口味分析 -->
      <div class="tag"
           v-if="itemAnalyse">
        <span class="placehold">></span>
        <el-tag closable
                class="tagName"
                @close="handleItemAnalyseClose">
          口味:{{html2Text(itemAnalyse)}}
        </el-tag>
      </div>
      <!-- 分析+的查询条件... -->
      <el-tooltip effect="light"
                  v-if="fxUrlId"
                  popper-class="fenxi-tooltip"
                  placement="bottom">
        <div slot="content"
             style="max-width:1000px;">
          <div class="fenxi-tool-content"
               style="font-size: 14px">
            <span class="fenxi-tool-plat">
              平台: {{fxUrlIdParams.plat}}
            </span>
            <span class="fenxi-tool-cat">
              类目:
              <span style="padding: 0; margin: 0">{{fxUrlIdParams.cat}}</span>
            </span>
            <span class="fenxi-tool-keyword"
                  v-if="!!fxUrlIdParams.keyword">
              关键词:
              <span>{{fxUrlIdParams.keyword}}</span>
            </span>
            <span class="fenxi-tool-avgPrice"
                  v-if="!!fxUrlIdParams.avgPrice">
              价格:
              <span>{{fxUrlIdParams.avgPrice}}</span>
            </span>
            <span class="fenxi-tool-sold"
                  v-if="!!fxUrlIdParams.sold">
              销量:
              <span>{{fxUrlIdParams.sold}}</span>
            </span>
            <span class="fenxi-tool-sales"
                  v-if="!!fxUrlIdParams.sales">
              销售额:
              <span>{{fxUrlIdParams.sales}}</span>
            </span>
            <span class="fenxi-tool-brand"
                  v-if="!!fxUrlIdParams.brand">
              品牌:
              <span>{{fxUrlIdParams.brand}}</span>
            </span>
            <span class="fenxi-tool-shop"
                  v-if="!!fxUrlIdParams.shop">
              店铺:
              <span>{{fxUrlIdParams.shop}}</span>
            </span>
            <span class="fenxi-tool-itemIds"
                  v-if="!!fxUrlIdParams.item_ids">
              商品ID:
              <span>{{ fxUrlIdParams.item_ids.split('\n').length > 1 ? fxUrlIdParams.item_ids.split('\n')[0] + ' ... ' : fxUrlIdParams.item_ids.split('\n')[0] }}</span>
            </span>
            <span class="fenxi-tool-rule"
                  v-if="!!fxUrlIdParams.rule">
              <span>{{fxUrlIdParams.rule}}</span>
            </span>
            <span class="fenxi-tool-onlineTime"
                  v-if="!!fxUrlIdParams.onlineTime">
              上架时间:
              <span>{{fxUrlIdParams.onlineTime}}</span>
            </span>
            <span class="fenxi-tool-filingDate"
                  v-if="!!fxUrlIdParams.filingDate">
              备案时间:
              <span>{{fxUrlIdParams.filingDate}}</span>
            </span>
            <span class="fenxi-tool-attr"
                  v-for="item in attrList"
                  :key="item.index">
              <span>
                {{ item.name }}: {{ item.value }}
              </span>
            </span>
            <span class="fenxi-tool-filingName"
                  v-if="!!fxUrlIdParams.filing_name">
              备案产品名称:
              <span>{{fxUrlIdParams.filing_name}}</span>
            </span>
          </div>
        </div>
        <div class="tag">
          <span class="placehold">></span>
          <el-tag closable
                  class="tagName"
                  @close="handleFxUrlIdClose">
            分析+的查询条件...
          </el-tag>
        </div>
      </el-tooltip>
      <div class="aspect-tag"
           v-for="item in scenelist"
           :key="item.index + item.name">
        <span class="placehold">></span>
        <el-tag closable
                :key="item.index"
                @close="handleScenelistClose(item)"
                class="aspectName">
          <template v-if="!item.analyse_typ">
            <span v-if="item.label_level == 2">{{item.label + '：'}}{{item.name}}{{transformType(item.type)}}</span>
            <span v-if="item.label_level == 1
                  && !item.ner_type
                  && !item.rule_id">{{item.label + '：'}}{{item.name}} {{item.view + '：'}}{{item.viewName}}{{transformType(item.type)}}</span>
            <span v-if="item.label_level == 1
                  && item.ner_type">{{item.label + '：'}}{{item.name}}{{transformType(item.type)}}</span>
            <span v-if="item.label_level == 1
                  && !item.ner_type
                  && item.rule_id">{{item.label + '：'}}{{item.name}}{{transformType(item.type)}}</span>
            <span v-if="item.label_level == ''
                  && !item.name.includes(',')">{{item.label + ':   '+ '"' + item.name+ '"'}}</span>
            <span v-if="item.label_level == ''
                  && item.name.includes(',')">{{item.label}}: 已选择{{item.name.split(',').length}}个{{item.label}}</span>
          </template>
          <template v-else-if="item.analyse_typ && item.rule_id">
            <span>{{item.label + ':   '+ '"' + item.name+ '"'}}</span>
          </template>
        </el-tag>
      </div>
      <div class="subscribe-area"
           @click="followClick">
        <i v-show="!isMarked"
           class="iconfont icon-heart-fill"
           style="color: #7d8a9b; margin-left: 12px; vertical-align: middle"></i>
        <i v-show="isMarked"
           class="iconfont icon-heart-fill"
           style="color: #ff7d00; margin-left: 12px; vertical-align: middle"></i>
        <span class="headText"
              v-show="!isMarked">
          <span style="vertical-align: middle; position: relative; top: 0px">＋</span>
          <span style="vertical-align: middle">关注</span>
        </span>
        <span class="headText"
              v-show="isMarked">
          <span style="vertical-align: middle; position: relative; top: 0px">＋</span>
          <span style="vertical-align: middle">已关注</span>
        </span>
      </div>
    </div>
    <div class="right-area">
      <div class="question-area">
        <QuestionSelect />
      </div>
      <div class="time-picker-area">
        <PickerCpn ref="PickerCpn" />
        <div style="margin-left: 20px">
          <el-button @click="confirm"
                     class="time-range-btn"
                     size="mini"
                     type="primary"> 确定 </el-button>
        </div>
      </div>
      <div class="pic-type-select-area"
           style="float: left;display: flex; align-items: center;justify-content: center;height: 40px;margin-left: 10px"
           v-show="true">
        <i class="iconfont icon-liebiao"></i>
        <el-select v-model="picType"
                   size="small"
                   class="item-select"
                   popper-class="pictype-select-popper"
                   :popper-append-to-body="false"
                   @change="changePicType">
          <el-option v-for="item in picTypeOptions"
                     :key="item.value"
                     :label='item.label'
                     :value='item.value'>
          </el-option>
        </el-select>
      </div>
    </div>
  </div>
</template>


<script>
import {
  getPlatCats,
  postUrlId,
  getUrlId,
  getFxUrlData,
} from '@/api/filter-header.js'
import { getAttention, putAttention, getUid } from '@/api/public.js'
import { deleteAttention } from '@/api/subscription'
import { paramsObj } from '@/mixins/mixins.js'
import {
  html2Text,
  getLastFullWeekStartAndEnd,
  formatDate,
  getNearestFullWeek,
} from '@/utils'
import CatTree from '../CatTree/index.vue'
import PickerCpn from './PickerCpn.vue'
import QuestionSelect from './QuestionSelect.vue'
import {
  changeUrlId,
  computeCustomFilter,
  computeAttrFilter,
} from '@/utils/handleUrlId'
import { buildSafeFilterParams } from '@/utils/filterParams'
import { DEFAULT_CID, PLAT_LIST } from '../defaultConfig'
export default {
  name: 'FilterHeader',
  data() {
    return {
      picType: '1,2',
      picTypeOptions: [
        {
          label: '全部评论',
          value: '1,2',
        },
        {
          label: '有图评论',
          value: '1',
        },
        {
          label: '无图评论',
          value: '2',
        },
      ],
      platOptions: [],
      plat: '',
      defaultCheckedKeys: [],
      selectIds: [],
      isMarked: false,
      dateTime: ['', ''],
      showCatTree: false,
      fxUrlIdParams: {
        plat: '',
        cat: '',
        keyword: '',
        avgPrice: '',
        sold: '',
        sales: '',
        brand: '',
        shop: '',
        rule: '',
        onlineTime: '',
        filingDate: '',
        filing_name: '',
        item_ids: '',
      },
      priceInteval: '',
      attrList: [],
      childrenCats: [],
      customCats: [],
      DEFAULT_CID: DEFAULT_CID,
      isChangePlat: false,
      isInit: true,
      cidList: [],
    }
  },
  props: {
    shopName: {
      type: Array,
      default: () => [],
    },
    brandName: {
      type: String,
      default: '',
    },
    itemName: {
      type: Array,
      default: () => [],
    },
    skuName: {
      type: Array,
      default: () => [],
    },
    itemAnalyse: {
      type: String,
      default: '',
    },
    navTabs: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    CatTree,
    // DatePicker,
    PickerCpn,
    QuestionSelect,
  },
  methods: {
    changePicType(val) {
      this.$store.dispatch('user/changePicType', val)
    },
    html2Text(val) {
      return html2Text(val)
    },
    removeQueryParam(param) {
      const query = { ...this.$route.query }
      const paramsToRemove = Array.isArray(param) ? param : [param]
      let hasChanged = false
      paramsToRemove.forEach((p) => {
        if (query.hasOwnProperty(p)) {
          delete query[p]
          hasChanged = true
        }
      })
      if (hasChanged) {
        this.$router.push({
          name: this.$route.name,
          query,
        })
      }
    },
    async handleShopClose() {
      this.removeQueryParam('shop')
      changeUrlId(null, 'shop_id', '').then(() => {
        this.$store.dispatch('user/changeShopId', '')
        if (this.$store.state.user.ActivedTab != 'AiInterpret') {
          this.$store.dispatch('user/changeActivedTab', 'Summary')
        }
      })
    },
    async handleItemClose() {
      const filterParams = buildSafeFilterParams(
        this.$store.state.user.filterParams,
        this.$route.query
      )
      filterParams.item_id = ''
      this.removeQueryParam('item_id')
      changeUrlId(filterParams).then(() => {
        this.$store.dispatch('user/changeItemId', '').then(() => {
          if (this.$store.state.user.ActivedTab != 'AiInterpret') {
            this.$store.dispatch('user/changeActivedTab', 'Summary')
          }
        })
      })
    },
    async handleSkuClose() {
      this.removeQueryParam('sku')
      changeUrlId(null, 'sku_id', '').then(() => {
        this.$store.dispatch('user/changeSkuId', '').then(() => {
          if (this.$store.state.user.ActivedTab != 'AiInterpret') {
            this.$store.dispatch('user/changeActivedTab', 'Summary')
          }
        })
      })
    },
    async handleBrandClose() {
      const filterParams = buildSafeFilterParams(
        this.$store.state.user.filterParams,
        this.$route.query
      )
      filterParams.brand_id = ''
      this.removeQueryParam('brand')
      await changeUrlId(filterParams).then(() => {
        this.$store.dispatch('user/changeBrandId', '').then(() => {
          this.$eventBus.$emit('deleteBrandWord')
          if (this.$store.state.user.ActivedTab != 'AiInterpret') {
            this.$store.dispatch('user/changeActivedTab', 'Summary')
          }
        })
      })
    },
    async handleContentClose() {
      this.removeQueryParam('content_word')
      changeUrlId(null, 'content_word', '').then(() => {
        this.$store.dispatch('user/changeContentWord', '').then(() => {
          this.$eventBus.$emit('deleteContentWord')
          if (this.$store.state.user.ActivedTab != 'AiInterpret') {
            this.$store.dispatch('user/changeActivedTab', 'Summary')
          }
        })
      })
    },
    async handlePriceClose() {
      this.removeQueryParam(['price_min', 'price_max'])
      changeUrlId(null, ['price_min', 'price_max'], ['', '']).then(() => {
        this.$store.dispatch('user/changePriceMin', '').then(() => {
          this.$store.dispatch('user/changePriceMax', '').then(() => {
            this.$eventBus.$emit('deletePriceWord')
            if (this.$store.state.user.ActivedTab != 'AiInterpret') {
              this.$store.dispatch('user/changeActivedTab', 'Summary')
            }
          })
        })
      })
    },
    async handleItemAnalyseClose() {
      changeUrlId(null, 'item_analyse', '').then(() => {
        this.$store.dispatch('user/changeItemAnalyse', '').then(() => {
          if (this.$store.state.user.ActivedTab != 'AiInterpret') {
            this.$store.dispatch('user/changeActivedTab', 'Summary')
          }
        })
      })
    },
    async handleFxUrlIdClose() {
      //   await changeUrlId(
      //     null,
      //     ['plat', 'cat_id', 'fx_url_id'],
      //     ['', '', '']
      //   ).then(() => {
      //     this.$store.dispatch('user/changePlat', '')
      //     this.$store.dispatch('user/changeCatId', '')
      //     this.$store.dispatch('user/changeFxUrlId', '')
      //     this.$store.dispatch('user/changeUrlId', '')
      //     this.$router.push({
      //       name: 'catSheet',
      //       cid: '',
      //       plat: '',
      //     })
      //     this.$store.dispatch('user/changeActivedTab', 'Summary')
      //   })
      this.$store.dispatch('user/changeFxUrlId', '')
      let query = _.cloneDeep(this.$route.query)
      this.$router.push({
        name: 'catSheet',
        cid: query.cid,
        plat: query.plat,
      })
      this.$store.dispatch('user/changeActivedTab', 'Summary')
    },
    transformType(val) {
      if (val == 'total') {
        return ''
      } else if (val == 'pos') {
        return '(正向)'
      } else if (val == 'neg') {
        return '(负向)'
      } else {
        return '(中性)'
      }
    },
    transformAttrName(val) {
      if (val == 'style_no') {
        return '款号'
      } else if (val == 'apply_scene') {
        return '适用场景'
      } else {
        return '性别'
      }
    },
    changePlat(val) {
      this.isChangePlat = true
      const loginCatlist = this.loginInfo.cat_list
      this.plat = val
      let r = this.rand_cat(loginCatlist)
      const filterParams = {
        plat: val,
        cat_id: r[1],
        url_id: r[1],
      }
      //   changeUrlId(filterParams).then(() => {
      this.defaultCheckedKeys = [r[1]]
      this.$store.dispatch('user/changePlat', val)
      this.$store.dispatch('user/changeStart', r[2])
      this.$store.dispatch('user/changeEnd', r[2])
      sessionStorage.setItem('tsType', 'month')
      this.$store.dispatch('user/changeTsType', 'month')
      if (this.fxUrlId == '') {
        this.$store.dispatch('user/changeCatId', r[1])
      }
      if (this.$store.state.user.ActivedTab != 'AiInterpret') {
        this.$store.dispatch('user/changeActivedTab', 'Summary')
      }
      this.$store.dispatch('user/changeLabelLevel', '')
      this.$store.dispatch('user/changeAspectType', '')
      this.$store.dispatch('user/changeWords', '')
      this.$store.dispatch('user/changeRouterAnalyseTyp', '')
      this.$store.dispatch('user/changeRouterRuleId', '')
      this.$store.dispatch('user/changeRouterNerType', '')
      this.$store.dispatch('user/changeShopId', '')
      this.$store.dispatch('user/changeBrandId', '')
      this.$store.dispatch('user/changeItemId', '')
      this.$store.dispatch('user/changeRouterRuleId', '')
      this.$store.dispatch('user/changeAttrId', '')
      this.$store.dispatch('user/changeAttrName', '')
      this.$store.dispatch('user/changeMultipleCatIdArr', [])
      this.$store.dispatch('user/changeCustomFilters', '')
      this.$store.dispatch('user/changeFilterParams', null)
      this.$store.dispatch('user/changeFxUrlId', '')
      this.$store.dispatch('user/changeContentWord', '')
      this.$store.dispatch('user/changePriceMin', '')
      this.$store.dispatch('user/changePriceMax', '')
      this.$store.dispatch('user/changeSkuId', '')
      this.$store.dispatch('user/changeSkuIdList', [])
      this.$store.dispatch('user/changeTitleWord', '')
      this.$store.dispatch('user/changeTitleWordList', [])
      this.$store.dispatch('user/changeTitleTyp', '')
      this.$store.dispatch('user/changeItemIdList', [])
      this.$store.dispatch('user/changeShopIdList', [])
      //   })
    },
    handleScenelistClose(item) {
      let index = item.index
      let query = _.cloneDeep(this.$route.query)
      if (this.customFilters.length == 1) {
        changeUrlId(null, 'custom_filters', '').then((url_id) => {
          this.$store.dispatch('user/changeCustomFilters', '')
          this.$store.dispatch('user/changeLabelLevel', '')
          this.$store.dispatch('user/changeAspectType', '')
          this.$store.dispatch('user/changeWords', '')
          this.$store.dispatch('user/changeRouterAnalyseTyp', '')
          this.$store.dispatch('user/changeRouterRuleId', '')
          this.$store.dispatch('user/changeRouterNerType', '')
          this.$store.dispatch('user/changeRouterAspLevel', '')
          if (query.aspect_source) {
            query.aspect_source = ''
          }
          query.url_id = url_id
          if (this.$store.state.user.ActivedTab != 'AiInterpret') {
            this.$store.dispatch('user/changeActivedTab', 'Summary')
          }
          this.$router.push({
            name: this.$route.name,
            query,
          })
        })
      } else if (this.customFilters.length > 1) {
        let labelLevelArr = this.$store.state.user.labelLevel
          .toString()
          .split(',')
        let aspectTypeArr = this.$store.state.user.aspectType.split(',')
        let wordsArr = []
        wordsArr = this.$store.state.user.words.split(',')
        let analyseTypArr = this.$store.state.user.routerAnalyseTyp.split(',')
        let ruleIdArr = this.$store.state.user.routerRuleId.split(',')
        let nerTypeArr = this.$store.state.user.routerNerType.split(',')
        let aspLevelArr = this.$store.state.user.routerAspLevel.split(',')
        labelLevelArr.splice(index, 1)
        aspectTypeArr.splice(index, 1)
        wordsArr.splice(index, 1)
        analyseTypArr.splice(index, 1)
        ruleIdArr.splice(index, 1)
        nerTypeArr.splice(index, 1)
        aspLevelArr.splice(index, 1)
        changeUrlId(
          null,
          'custom_filters',
          computeCustomFilter({
            words: wordsArr.join(','),
            aspect_type: aspectTypeArr.join(','),
            label_level: labelLevelArr.join(','),
            analyse_typ: analyseTypArr.join(','),
            rule_id: ruleIdArr.join(','),
            ner_type: nerTypeArr.join(','),
            asp_level: aspLevelArr.join(','),
          })
        ).then((url_id) => {
          this.$store.dispatch('user/changeLabelLevel', labelLevelArr.join(','))
          this.$store.dispatch('user/changeAspectType', aspectTypeArr.join(','))
          this.$store.dispatch('user/changeWords', wordsArr.join(','))
          this.$store.dispatch(
            'user/changeRouterAnalyseTyp',
            analyseTypArr.join(',')
          )
          this.$store.dispatch('user/changeRouterRuleId', ruleIdArr.join(','))
          this.$store.dispatch('user/changeRouterNerType', nerTypeArr.join(','))
          this.$store.dispatch(
            'user/changeRouterAspLevel',
            aspLevelArr.join(',')
          )
          if (query.aspect_source) {
            let aspect_source_arr = query.aspect_source.split(',')
            aspect_source_arr.splice(index, 1)
            query.aspect_source = aspect_source_arr.join(',')
          }
          query.url_id = url_id
          if (this.$store.state.user.ActivedTab != 'AiInterpret') {
            this.$store.dispatch('user/changeActivedTab', 'Summary')
          }
          this.$router.push({
            name: this.$route.name,
            query,
          })
        })
      }
    },
    handleAttrListClose(item) {
      let index = item.index
      let query = _.cloneDeep(this.$route.query)
      if (this.attrFilters.length == 1) {
        changeUrlId(null, 'attr_filters', computeAttrFilter({})).then(
          (url_id) => {
            this.$store.dispatch('user/changeAttrId', '')
            this.$store.dispatch('user/changeAttrName', '')
            delete query.attr_id
            delete query.attr_name
            query.url_id = url_id
            if (this.$store.state.user.ActivedTab != 'AiInterpret') {
              this.$store.dispatch('user/changeActivedTab', 'Summary')
            }
            this.$router.push({
              name: this.$route.name,
              query,
            })
          }
        )
      } else if (this.attrFilters.length > 1) {
        let attrIdArr = this.$store.state.user.attrId.split(',')
        let attrNameArr = this.$store.state.user.attrName.split(',')
        attrIdArr.splice(index, 1)
        attrNameArr.splice(index, 1)
        changeUrlId(
          null,
          'attr_filters',
          computeAttrFilter({
            attr_name: attrNameArr.join(','),
            attr_id: attrIdArr.join(','),
          })
        ).then((url_id) => {
          this.$store.dispatch('user/changeAttrId', attrIdArr.join(','))
          this.$store.dispatch('user/changeAttrName', attrNameArr.join(','))
          // query.attr_id = this.$store.state.user.attrId
          // query.attr_name = this.$store.state.user.attrName
          query.url_id = url_id
          if (this.$store.state.user.ActivedTab != 'AiInterpret') {
            this.$store.dispatch('user/changeActivedTab', 'Summary')
          }
          this.$router.push({
            name: this.$route.name,
            query,
          })
        })
      }
    },
    handleTitleClose(item) {
      const { index } = item
      let query = _.cloneDeep(this.$route.query)
      let titleWordParam = '',
        titleWordArr = '',
        titleTypArr = ''
      if (this.titleFilters.length > 1) {
        this.titleFilters.splice(index, 1)
        titleWordParam = JSON.stringify(this.titleFilters)
        titleWordArr = this.titleFilters.map((item) => item.word).join(',')
        titleTypArr = this.titleFilters.map((item) => item.title_typ).join(',')
        this.$store.dispatch('user/changeTitleWordList', this.titleFilters)
      }
      changeUrlId(null, 'title_word', titleWordParam).then((url_id) => {
        this.$store.dispatch('user/changeTitleWord', titleWordArr)
        this.$store.dispatch('user/changeTitleTyp', titleTypArr)
        this.$eventBus.$emit('deleteTitleWord', titleWordArr)
        if (this.$store.state.user.ActivedTab != 'AiInterpret') {
          this.$store.dispatch('user/changeActivedTab', 'Summary')
        }
        query.url_id = url_id
        this.$router.push({
          name: this.$route.name,
          query,
        })
      })
    },
    getMarkedMethods() {
      const { cid, plat } = this.$route.query
      const {
        brandId,
        contentWord,
        itemAnalyse,
        fxUrlId,
        itemId,
        parentCatId,
        priceMax,
        priceMin,
        shopId,
        skuId,
        titleWord,
        titleTyp,
        titleWord_list,
      } = this.$store.state.user
      let typ = titleTyp
      if (contentWord || titleWord || itemId) {
        if (contentWord) {
          typ = 'content'
        }
        if (titleWord || (itemId && !contentWord)) {
          typ = 'title'
        }
      } else {
        if (shopId) {
          typ = 'shop'
        } else if (brandId && brandId !== 'all') {
          typ = 'brand'
        } else {
          typ = 'cat'
        }
      }
      const params = {
        brand_id: brandId,
        cat_id: cid,
        content_word: contentWord,
        fx_url_id: fxUrlId,
        item_analyse: itemAnalyse,
        item_id: itemId,
        parent_cat_id: parentCatId,
        plat: plat,
        price_max: priceMax,
        price_min: priceMin,
        shop_id: shopId,
        sku_id: skuId,
        title_word: titleWord,
        typ: typ,
        url_id: cid,
      }
      if (titleWord_list && titleWord_list.length > 0) {
        params.title_word = JSON.stringify(titleWord_list)
      } else {
        params.title_word = titleWord
      }
      getAttention(params).then((res) => {
        if (res.status == 'ok') {
          const result = res.result
          if (result.count && result.count > 0) {
            this.isMarked = true
          } else {
            this.isMarked = false
          }
        } else {
          this.isMarked = false
        }
      })
    },
    followClick() {
      const { cid, plat } = this.$route.query
      const {
        brandId,
        contentWord,
        itemAnalyse,
        fxUrlId,
        itemId,
        parentCatId,
        priceMax,
        priceMin,
        shopId,
        skuId,
        titleWord,
        titleTyp,
        titleWord_list,
      } = this.$store.state.user
      let typ = titleTyp
      if (contentWord || titleWord || itemId) {
        if (contentWord) {
          typ = 'content'
        }
        if (titleWord || (itemId && !contentWord)) {
          typ = 'title'
        }
      } else {
        if (shopId) {
          typ = 'shop'
        } else if (brandId && brandId !== 'all') {
          typ = 'brand'
        } else {
          typ = 'cat'
        }
      }
      const params = {
        brand_id: brandId,
        cat_id: cid,
        content_word: contentWord,
        fx_url_id: fxUrlId,
        item_analyse: itemAnalyse,
        item_id: itemId,
        parent_cat_id: parentCatId,
        plat: plat,
        price_max: priceMax,
        price_min: priceMin,
        shop_id: shopId,
        sku_id: skuId,
        title_word: titleWord,
        typ: typ,
        url_id: cid,
      }

      if (
        typeof this.$store.state.user.words !== 'string' &&
        this.$store.state.user.words &&
        this.$store.state.user.words.split(',').length > 0
      ) {
        let customFilters = []
        for (
          let i = 0;
          i < this.$store.state.user.words.split(',').length;
          i++
        ) {
          let aspect_type = this.$store.state.user.aspectType.split(',')[i]
          if (
            this.$store.state.user.aspectType.split(',')[i] ==
              'neg_percentage' ||
            this.$store.state.user.aspectType.split(',')[i] == 'total_neg' ||
            this.$store.state.user.aspectType.split(',')[i] == 'new_neg_per'
          ) {
            aspect_type = 'neg'
          }
          let _customFilter = {
            rule_id: this.$store.state.user.routerRuleId.split(',')[i],
            analyse_typ: this.$store.state.user.routerAnalyseTyp.split(',')[i],
            ner_type: this.$store.state.user.routerNerType.split(',')[i],
            label_level: this.$store.state.user.labelLevel.split(',')[i],
            aspect_type: aspect_type,
          }
          let words = this.$store.state.user.words.split(',')[i]
          if (words.split('_').length > 1) {
            _customFilter['words'] = words.split('_')[0]
            _customFilter['opinions'] = words.split('_')[1]
          } else {
            _customFilter['words'] = this.$store.state.user.words.split(',')[i]
          }
          customFilters.push(_customFilter)
        }
        params.custom_filters = JSON.stringify(customFilters)
      } else if (
        this.$store.state.user.words &&
        typeof this.$store.state.user.words == 'string'
      ) {
        let customFilters = []
        let aspect_type = this.$store.state.user.aspectType
        if (
          this.$store.state.user.aspectType == 'neg_percentage' ||
          this.$store.state.user.aspectType == 'total_neg' ||
          this.$store.state.user.aspectType == 'new_neg_per'
        ) {
          aspect_type = 'neg'
        }
        let _customFilter = {
          rule_id: this.$store.state.user.routerRuleId,
          analyse_typ: this.$store.state.user.routerAnalyseTyp,
          ner_type: this.$store.state.user.routerNerType,
          label_level: this.$store.state.user.labelLevel,
          aspect_type: aspect_type,
        }
        let words = this.$store.state.user.words
        if (words.split('_').length > 1) {
          _customFilter['words'] = words.split('_')[0]
          _customFilter['opinions'] = words.split('_')[1]
        } else {
          _customFilter['words'] = this.$store.state.user.words
        }
        customFilters.push(_customFilter)
        params.custom_filters = JSON.stringify(customFilters)
      }
      if (this.$store.state.user.attrFilters) {
        params.attr_filters = JSON.stringify(this.$store.state.user.attrFilters)
      }
      if (titleWord_list && titleWord_list.length > 0) {
        params.title_word = JSON.stringify(titleWord_list)
      } else {
        params.title_word = titleWord
      }
      let api = putAttention
      if (this.isMarked) {
        api = deleteAttention
      }
      api(params).then((res) => {
        if (res.status == 'ok') {
          this.isMarked = !this.isMarked
        }
      })
    },
    confirm() {
      this.dateTime = this.$refs.PickerCpn.dateTime
      const query = _.cloneDeep(this.$route.query)
      query.start = this.dateTime[0]
      query.end = this.dateTime[1]
      this.$router.push({
        name: 'catSheet',
        query,
      })
    },
    fixPlatOrder(arr) {
      const order = ['jd', 'tmall', 'douyin', 'custom', 'amazon_us']
      arr.sort((a, b) => {
        const indexA = order.indexOf(a.value)
        const indexB = order.indexOf(b.value)
        return indexA - indexB
      })
      return arr
    },
    changeCatById(val) {
      if (!this.$refs.CatTree) {
        return
      }
      const catInfo = this.$refs.CatTree.getCatInfoById(val)
      if (!catInfo) {
        return
      }
      const filterParams = buildSafeFilterParams(
        this.$store.state.user.filterParams,
        this.$route.query
      )
      filterParams.cat_id = catInfo.id
      filterParams.parent_cat_id = catInfo.parent_id
      changeUrlId(filterParams).then(() => {
        this.defaultCheckedKeys = [catInfo.id]
        this.$store.dispatch('user/changeCatId', catInfo.id)
        this.$store.dispatch('user/changeParentCatId', catInfo.parent_id)
        if (this.$store.state.user.ActivedTab != 'AiInterpret') {
          this.$store.dispatch('user/changeActivedTab', 'Summary')
        }
      })
    },
    getFxUrlDataPromise() {
      let param = {
        fx_url_id: this.fxUrlId,
        comment_user: this.$store.state.user.loginInfo.username,
      }
      getFxUrlData(param).then((res) => {
        const { data } = res.result.data.data
        let plat = this.plat ? this.plat : this.$route.query.plat
        this.fxUrlIdParams.plat = PLAT_LIST.find((item) => {
          return item.value == plat
        }).label
        this.fxUrlIdParams.cat = data.cats.map((item) => item.name).join(',')
        this.fxUrlIdParams.keyword = data.title
        this.fxUrlIdParams.brand = data.brand
        this.fxUrlIdParams.shop = data.shop_name
        this.fxUrlIdParams.rule = data.rule
        this.fxUrlIdParams.avgPrice = this.compareCalFunc(data.avg_price)
          ? this.compareCalFunc(data.avg_price) + '元'
          : ''
        this.fxUrlIdParams.sold = this.compareCalFunc(data.sold)
          ? this.compareCalFunc(data.sold) + '件'
          : ''
        this.fxUrlIdParams.sales = this.compareCalFunc(data.sales)
          ? this.compareCalFunc(data.sales) + '万元'
          : ''
        this.fxUrlIdParams.onlineTime = this.compareCalFunc(
          data.online_time,
          'time'
        )
          ? this.compareCalFunc(data.online_time, 'time')
          : ''
        this.fxUrlIdParams.filingDate = this.compareCalFunc(
          data.filing_date,
          'time'
        )
          ? this.compareCalFunc(data.filing_date, 'time')
          : ''
        this.fxUrlIdParams.filing_name = data.filing_name
        this.fxUrlIdParams.item_ids = data.item_ids
        this.attrList = data.attr_filters
      })
    },
    compareCalFunc(val, param) {
      if (val.length == 0) {
        return false
      } else if (val[0] == '' && val[1] == '') {
        return false
      } else if (val[0] !== '' && val[1] !== '') {
        return val[0] + '~' + val[1]
      } else if (val[0] == '' && val[1] !== '') {
        return param == 'time' ? val[1] + '之前' : '<=' + val[1]
      } else if (val[0] !== '' && val[1] == '') {
        return param == 'time' ? val[0] + '之后' : '>=' + val[0]
      }
    },
    initData() {
      let { plat, cid } = this.$route.query
      getPlatCats().then((res) => {
        if (res.status == 'ok') {
          const result = res.result
          let resultOptions = []
          const loginCatlist = this.$store.state.user.loginInfo.cat_list
          let platList = PLAT_LIST
          if (!this.loginInfo.is_add_custom) {
            //非自定义权限账号不显示自定义平台
            platList = _.filter(platList, function (o) {
              return o.value != 'custom'
            })
          }
          if (loginCatlist != 'all') {
            const propertyNames = Object.keys(loginCatlist).filter((key) => {
              return Object.values(loginCatlist[key]).some(
                (arr) => arr.length > 0
              )
            })
            resultOptions = platList.filter((item) => {
              return propertyNames.includes(item.value)
            })
          } else {
            Object.keys(result).forEach((item) => {
              const option = platList.find((ele) => ele.value == item)
              if (option) {
                resultOptions.push(option)
              }
            })
          }
          this.platOptions = this.fixPlatOrder(resultOptions)
          this.$store.dispatch('user/changePlatCats', result)
          // 记录有权限的类目
          if (plat == 'jd') {
            this.cidList = [...result.jd.cids, ...result.jd.pids]
          } else if (plat == 'tmall') {
            this.cidList = [...result.tmall.cids, ...result.tmall.pids]
          } else if (plat == 'douyin') {
            this.cidList = [...result.douyin.cids, ...result.douyin.pids]
          } else if (plat == 'custom') {
            this.cidList = [...result.custom.cids, ...result.custom.pids]
          } else if (plat == 'amazon_us') {
            this.cidList = [...result.amazon_us.cids, ...result.amazon_us.pids]
          }
          let noPermission = false
          if (loginCatlist !== 'all' && plat) {
            let cat_list = loginCatlist[plat]
            // cat_list 为空，说明该用户没有权限
            let arrs = Object.keys(cat_list).find((v) => cat_list[v].length > 0)
            if (arrs) {
              noPermission = false
            } else {
              noPermission = true
            }
          }
          if (noPermission) {
            this.showCatTree = false
            if (this.fxUrlId) {
              let options = platList.filter((item) => {
                return item.value == plat
              })
              this.platOptions = this.fixPlatOrder(options)
            }
            return
          }
          this.customCats = result.custom.pids
          if (plat && cid) {
            this.plat = plat
            const numberRegex = /^\d+$/
            const singleCid = numberRegex.test(cid)
            let customIndex = this.customCats.findIndex((item) => {
              return _.includes(cid, item)
            })
            if (singleCid || customIndex > -1) {
              const datas = this.cacheData
              const childrenList = datas ? datas.result.childrenList : undefined
              if (datas && childrenList) {
                if (
                  plat == 'jd' &&
                  this.$store.state.user.filterParams &&
                  this.$store.state.user.filterParams.cat_id &&
                  this.$store.state.user.filterParams.cat_id == cid &&
                  !childrenList[cid]
                ) {
                  cid =
                    this.$store.state.user.filterParams.parent_cat_id +
                    '_' +
                    cid
                }
                // 如果当前选择类目没权限，就给有权限的类目
                let cidIndex = this.cidList.findIndex((ele) => ele == cid)
                if (cidIndex == -1) {
                  if (!childrenList[cid]) {
                    this.getMultipleCid(cid)
                    return
                  }
                  const parent_id = childrenList[cid].parent_id
                  if (childrenList[parent_id]) {
                    let childIndex = childrenList[parent_id].chd.findIndex(
                      (ele) => ele == cid
                    )
                    if (childIndex > -1) {
                      this.defaultCheckedKeys = [cid]
                    } else {
                      this.defaultCheckedKeys = [this.cidList[0]]
                    }
                  } else {
                    return
                  }
                } else {
                  this.defaultCheckedKeys = [cid]
                }
              } else {
                this.defaultCheckedKeys = [cid]
              }
              this.showCatTree = true
              this.$store.dispatch('user/changeMultipleCatIdArr', [])
              if (datas && childrenList) {
                const parent_id = childrenList[cid].parent_id
                if (parent_id) {
                  this.$store.dispatch('user/changeParentCatId', parent_id)
                }
              }
            } else {
              this.getMultipleCid(cid)
            }
          } else {
            this.plat = this.platOptions[0] ? this.platOptions[0].value : ''
            const cat_list = this.$store.state.user.loginInfo.cat_list
            if (Array.isArray(cat_list) && cat_list.length === 0) {
              return
            }
            let r = this.rand_cat(cat_list)
            this.defaultCheckedKeys = [r[1]]
            this.$store.dispatch('user/changePlat', r[0])
            this.$store.dispatch('user/changeCatId', r[1])
            this.$store.dispatch('user/changeStart', r[2])
            this.$store.dispatch('user/changeEnd', r[2])
            this.showCatTree = true
            this.$store.dispatch('user/changeMultipleCatIdArr', [])
          }
          // this.changePlat(this.plat)
        }
      })
    },
    rand_cat(catlist) {
      let cid = '',
        plat = this.plat,
        ts = '',
        _this = this
      if (catlist == 'all') {
        getDefaultId()
      } else {
        _.forEach(
          ['jd', 'tmall', 'douyin', 'custom', 'amazon_us'],
          function (p) {
            if (plat && plat !== p) {
              return
            }
            _.each(catlist[p], function (v, k) {
              if (v.length > 0 && !cid) {
                cid = v[0]['cat_id']
                ts = v[0].ts
                plat = p
                return false
              }
            })
          }
        )
        if (!cid || !plat) {
          getDefaultId()
        }
      }
      function getDefaultId() {
        plat = plat || 'jd'
        cid = cid || _this.DEFAULT_CID[plat]
        const latestTime = _this.$store.state.user.latestTime
        if (latestTime) {
          const timeArr = latestTime[plat]
          if (timeArr[2] && Object.keys(timeArr[2]).length > 0) {
            if (timeArr[2][cid]) {
              ts = timeArr[2][cid][1]
            } else {
              ts = timeArr[1]
            }
          } else {
            ts = timeArr[1]
          }
        }
      }
      return [plat, cid, ts]
    },
    getMultipleCid(cid) {
      getUrlId({ url_id: cid }).then((res) => {
        if (res.status == 'ok') {
          const { cats } = res.result.data
          this.$store.dispatch('user/changeMultipleCatIdArr', cats)
          this.childrenCats = []
          cats.forEach((item) => {
            this.childrenCats.push(item)
          })
          const datas = this.cacheData
          const childrenList = datas ? datas.result.childrenList : undefined
          if (datas && childrenList) {
            let availableCidList = []
            // 如果当前选择类目没权限，就给有权限的类目
            this.childrenCats.forEach((item) => {
              if (item.cat_id) {
                let cidIndex = this.cidList.findIndex(
                  (ele) => ele == item.cat_id
                )
                if (cidIndex == -1) {
                  let cat_id = item.cat_id
                  if (
                    !childrenList[item.cat_id] &&
                    this.plat == 'jd' &&
                    item.parent_id
                  ) {
                    cat_id = item.parent_id + '_' + item.cat_id //jd四级类目存在特殊情况需单独处理
                  }
                  const parent_id = childrenList[cat_id].parent_id
                  let childIndex = childrenList[parent_id].chd.findIndex(
                    (ele) => ele == cat_id
                  )
                  if (childIndex > -1) {
                    availableCidList.push(cat_id)
                  }
                } else {
                  availableCidList.push(item.cat_id)
                }
              } else {
                let cidIndex = this.cidList.findIndex((ele) => ele == item)
                if (cidIndex == -1) {
                  const parent_id = childrenList[item].parent_id
                  let childIndex = childrenList[parent_id].chd.findIndex(
                    (ele) => ele == item
                  )
                  if (childIndex > -1) {
                    availableCidList.push(item)
                  }
                } else {
                  availableCidList.push(item)
                }
              }
            })
            if (availableCidList.length > 0) {
              this.defaultCheckedKeys = availableCidList
            } else {
              this.defaultCheckedKeys = [this.cidList[0]]
            }
          } else {
            let availableCidList = []
            this.childrenCats.forEach((item) => {
              if (item.cat_id) {
                availableCidList.push(item.cat_id)
              } else {
                availableCidList.push(item)
              }
            })
            if (availableCidList.length > 0) {
              this.defaultCheckedKeys = availableCidList
            } else {
              this.defaultCheckedKeys = [this.cidList[0]]
            }
          }
          this.showCatTree = true
        }
      })
    },
    resetJump(param) {
      let query = _.cloneDeep(this.$route.query)
      // getUid(this.urlParams).then((res) => {
      //   if (res.status == 'ok') {
      //     this.$store.dispatch('user/changeUrlId', res.result).then(() => {
      //       let newQuery = param || query
      //       newQuery.url_id = res.result
      //       this.$router.push({
      //         name: 'catSheet',
      //         query: newQuery,
      //       })
      //     })
      //   }
      // })

      let newQuery = param || query
      this.$router.push({
        name: 'catSheet',
        query: newQuery,
      })
    },
    setStartAndEnd(catArr) {
      if (this.$store.state.user.ActivedTab == 'AiInterpret') {
        this.isInit = true
      }
      const cat_list = this.$store.state.user.loginInfo.cat_list
      const latestTime = this.$store.state.user.latestTime
      const timeArr = latestTime[this.plat]
      let query = _.cloneDeep(this.$route.query)
      let tsType = this.$store.state.user.tsType
      let cats = _.map(catArr, 'cat_id')
      const isDay = cats.some(
        (item) =>
          item &&
          (item.includes('model_bestore_daily_tmall') ||
            item.includes('model_bestore_daily_jd'))
      )
      const ismouth = cats.some(
        (item) =>
          item &&
          (item.includes('model_bestore_month_tmall') ||
            item.includes('model_bestore_month_jd'))
      )
      if (isDay) {
        tsType = 'day'
      }
      if (ismouth) {
        tsType = 'month'
      }
      let ts = '',
        DataTime = { start: '', end: '' }
      let start = timeArr[1],
        end = timeArr[1]
      let catPathArr = []
      for (let i = 0; i < catArr.length; i++) {
        if (catArr[i]) {
          catPathArr.push(this.$refs.CatTree.getCatInfoById(catArr[i]).cid_path)
        }
      }
      let allCatPathArr = _.uniq(_.flatten(catPathArr)) //所选类目(包含父类目)的cid数组集合
      if (timeArr[2] && Object.keys(timeArr[2]).length > 0) {
        let arr = []
        for (let i = 0; i < allCatPathArr.length; i++) {
          let item = allCatPathArr[i]
          if (timeArr[2][item]) {
            arr.push([timeArr[2][item][0], timeArr[2][item][1]])
          }
        }
        if (arr.length > 0) {
          let arr1 = _.map(arr, (item) => item[0])
          let arr2 = _.map(arr, (item) => item[1])
          // if(isDay){
          //     arr1 = _.map(arr, (item) =>
          //         formatDate(
          //             new Date(item[0].split('-')[0], item[0].split('-')[1], 0),
          //             '{y}-{m}-{d}'
          //         )
          //     )
          //     arr2 = _.map(arr, (item) =>
          //         formatDate(
          //             new Date(item[1].split('-')[0], item[1].split('-')[1], 0),
          //             '{y}-{m}-{d}'
          //         )
          //     )
          // }
          let f1 = arr1.map((dateStr) => new Date(dateStr).getTime())
          const startTime = new Date(Math.max(...f1))
          let f2 = arr2.map((dateStr) => new Date(dateStr).getTime())
          const endTime = new Date(Math.min(...f2))
          if (startTime > endTime) {
            this.$message.error('所选类目没有可查看时间的数据')
            return
          }
          if (isDay || tsType == 'week') {
            DataTime.start = startTime.toISOString().slice(0, 10)
            DataTime.end = endTime.toISOString().slice(0, 10)
          } else {
            DataTime.start = startTime.toISOString().slice(0, 7)
            DataTime.end = endTime.toISOString().slice(0, 7)
          }
        } else {
          DataTime.start = timeArr[0]
          DataTime.end = timeArr[1]
        }
      } else {
        DataTime.start = timeArr[0]
        DataTime.end = timeArr[1]
      }
      if (cat_list == 'all') {
        start = DataTime.end
        end = DataTime.end
      } else {
        const platCatList = cat_list[this.plat]
        const datas = _.flatMap(platCatList)
        const result = _.filter(datas, (obj) =>
          allCatPathArr.includes(obj.cat_id)
        )
        if (result.length > 0) {
          let tsArr = _.map(result, 'ts')
          let f2 = tsArr.map((dateStr) => new Date(dateStr).getTime())
          const minTs = new Date(Math.min(...f2))
          if (isDay) {
            ts = minTs.toISOString().slice(0, 10)
          } else {
            ts = minTs.toISOString().slice(0, 7)
          }
          start = ts
          end = ts
          if (DataTime.end < ts) {
            start = DataTime.end
            end = DataTime.end
          }
        }
      }
      this.$store.dispatch('user/changePlatTime', {
        end: DataTime.end,
        start: DataTime.start,
      })
      if (!this.isChangePlat) {
        if (tsType == 'month') {
          start = start.slice(0, 7)
          end = end.slice(0, 7)
        } else if (tsType == 'week') {
          let time = getLastFullWeekStartAndEnd(
            end.slice(5, 7),
            end.slice(0, 4)
          )
          if (end.split('-').length == 3) {
            time = getNearestFullWeek(end)
          }
          start = time.start
          end = time.end
        } else if (tsType == 'day') {
          if (end.split('-').length != 3) {
            start =
              start.slice(0, 7) +
              '-' +
              new Date(start.slice(0, 4), start.slice(5, 7), 0).getDate()
            end =
              end.slice(0, 7) +
              '-' +
              new Date(end.slice(0, 4), end.slice(5, 7), 0).getDate()
          }
        }
      }
      if (query.start && !this.isChangePlat && this.isInit) {
        start = query.start
      }
      if (query.end && !this.isChangePlat && this.isInit) {
        end = query.end
      }
      if (
        this.plat == 'custom' &&
        cats.some((pattern) =>
          ['model_example_kitchen', 'model_example_snacks'].some((target) =>
            pattern.includes(target)
          )
        )
      ) {
        start = DataTime.start
        end = DataTime.end
      }
      this.$store.dispatch('user/changeStart', start)
      this.$store.dispatch('user/changeEnd', end)
      this.isChangePlat = false
      this.isInit = false
      //   this.$router.push({
      //     name: this.$route.name,
      //     query,
      //   })
    },
  },
  mixins: [paramsObj],
  created() {
    this.getMarked = _.debounce(this.getMarkedMethods, 300)
    this.resetJumpDebounce = _.debounce(this.resetJump, 500)
    this.initData()
    if (this.fxUrlId) {
      this.getFxUrlDataPromise()
    }
    const { priceMin, priceMax } = this.$store.state.user
    if (priceMin && priceMax) {
      this.priceInteval = priceMin + '~' + priceMax + '元'
    } else if (priceMin && !priceMax) {
      this.priceInteval = '≥' + priceMin + '元'
    } else if (!priceMin && priceMax) {
      this.priceInteval = '≤' + priceMax + '元'
    }
  },
  mounted() {
    this.$eventBus.$on('changeCatById', this.changeCatById)
    setTimeout(() => {
      this.getMarked()
    }, 1000)
  },
  beforeDestroy() {
    this.$eventBus.$off('changeCatById')
  },
  computed: {
    latestTime() {
      return this.$store.state.user.latestTime
    },
    cacheData() {
      let datas
      switch (this.plat) {
        case 'jd':
          datas = window.cache_cat_jd
          break
        case 'tmall':
          datas = window.cache_cat
          break
        case 'custom':
          datas = window.cache_cat_custom
          break
        case 'douyin':
          datas = window.cache_douyin_cats
          break
        case 'amazon_us':
          datas = window.cache_cat_amazon_us
          break
        default:
          datas = window.cache_cat_jd
      }
      return datas
    },
    loginInfo() {
      return this.$store.state.user.loginInfo
    },
    customFilters() {
      return this.$store.state.user.customFilters
    },
    titleWord() {
      return this.$store.state.user.titleWord
    },
    contentWord() {
      return this.$store.state.user.contentWord
    },
    priceMin() {
      return this.$store.state.user.priceMin
    },
    priceMax() {
      return this.$store.state.user.priceMax
    },
    fxUrlId() {
      return this.$store.state.user.fxUrlId
    },
    attrFilters() {
      return this.$store.state.user.attrFilters
    },
    titleFilters() {
      return this.$store.state.user.titleFilters
    },
    scenelist() {
      let aspect_source = this.$route.query.aspect_source
        ? this.$route.query.aspect_source.split(',')
        : []
      if (this.customFilters && this.customFilters.length > 0) {
        let tagString = []
        // 循环遍历customFilters的值，如果label不存在，就把words按照下划线分隔，再赋值给字符串数组。
        // 方面子图表和观点的逻辑一致
        for (let i = 0; i < this.customFilters.length; i++) {
          const item = this.customFilters[i]
          const label = item.label_level
          const rule_id = decodeURIComponent(item.rule_id)
          const analyse_typ = decodeURIComponent(item.analyse_typ)
          const ner_type = item.ner_type
          const aspLevel = item.asp_level
          const navTabs = _.cloneDeep(this.navTabs)
          const ruleIndex = navTabs.findIndex(
            (element) => element.rule_id == item.rule_id
          )
          let ruleName = navTabs[ruleIndex] ? navTabs[ruleIndex].title : '方面'
          let words = item.words
          let opinions = item.opinions
          if (aspect_source.length > 0) {
            if (aspect_source[i]) {
              if (aspect_source[i].split('_').length > 1) {
                words = aspect_source[i].split('_')[0]
                opinions = aspect_source[i].split('_')[1]
              } else {
                words = aspect_source[i]
              }
            }
          }
          if (!analyse_typ) {
            if (label == 2 && !ner_type) {
              if (aspLevel == 'level1') {
                tagString.push({
                  label: '一级指标',
                  name: decodeURIComponent(words),
                  type: decodeURIComponent(item.aspect_type),
                  label_level: label,
                  index: i,
                  analyse_typ: analyse_typ,
                })
              } else if (aspLevel == 'level2') {
                tagString.push({
                  label: '二级指标',
                  name: decodeURIComponent(words),
                  type: decodeURIComponent(item.aspect_type),
                  label_level: label,
                  index: i,
                  analyse_typ: analyse_typ,
                })
              } else {
                tagString.push({
                  label: '方面',
                  name: decodeURIComponent(words),
                  type: decodeURIComponent(item.aspect_type),
                  label_level: label,
                  index: i,
                  analyse_typ: analyse_typ,
                })
              }
            } else if (label == 1 && !ner_type && !rule_id) {
              tagString.push({
                label: '方面',
                name: decodeURIComponent(words),
                view: '观点',
                viewName: decodeURIComponent(opinions),
                type: decodeURIComponent(item.aspect_type),
                label_level: label,
                index: i,
                rule_id: rule_id,
                analyse_typ: analyse_typ,
              })
            } else if (label == 1 && !ner_type && rule_id) {
              tagString.push({
                label: ruleName,
                name: decodeURIComponent(words),
                type: decodeURIComponent(item.aspect_type),
                ner_type: decodeURIComponent(ner_type),
                label_level: label,
                index: i,
                rule_id: rule_id,
                analyse_typ: analyse_typ,
              })
            } else if (ner_type) {
              tagString.push({
                label: ruleName,
                name: decodeURIComponent(words),
                type: decodeURIComponent(item.aspect_type),
                ner_type: decodeURIComponent(ner_type),
                label_level: label,
                index: i,
              })
            } else {
              tagString.push({
                label: ruleName,
                name: decodeURIComponent(words),
                type: decodeURIComponent(item.aspect_type),
                label_level: label,
                index: i,
              })
            }
          } else if (analyse_typ && rule_id) {
            tagString.push({
              label: ruleName,
              name: decodeURIComponent(words),
              type: decodeURIComponent(item.aspect_type),
              label_level: label,
              index: i,
              analyse_typ: analyse_typ,
              rule_id: rule_id,
            })
          }
        }
        return tagString
      } else {
        return []
      }
    },
    attrlist() {
      if (this.attrFilters && this.attrFilters.length > 0) {
        let attrString = []
        for (let i = 0; i < this.attrFilters.length; i++) {
          const item = this.attrFilters[i]
          const attrId = item.value
          const attrName = item.attr
          attrString.push({
            index: i,
            attrName: attrName,
            attrId: attrId,
          })
        }
        return attrString
      } else {
        return []
      }
    },
    titlelist() {
      if (this.titleFilters && this.titleFilters.length > 0) {
        let titleString = []
        for (let i = 0; i < this.titleFilters.length; i++) {
          const item = this.titleFilters[i]
          const word = item.word
          const titleTyp = item.title_typ
          titleString.push({
            index: i,
            word,
            titleTyp,
          })
        }
        return titleString
      } else {
        return []
      }
    },
    is_add_custom() {
      return this.$store.state.user.loginInfo.is_add_custom
    },
  },
  watch: {
    paramsObj: {
      handler(newVal, oldVal) {
        const { plat, catId, start, end, url_id } = newVal
        const { priceMax, priceMin } = this.$store.state.user
        let query = _.cloneDeep(this.$route.query)
        if (plat) {
          query.plat = plat
          this.plat = plat
        }
        if (catId) {
          query.cid = catId
          //   if (this.childrenCats && this.childrenCats.length > 0) {
          //     this.defaultCheckedKeys = this.childrenCats
          //   } else {
          //     this.defaultCheckedKeys = [catId]
          //   }
        }
        // 价格搜索的最小值和最大值
        if (priceMin && priceMax) {
          this.priceInteval = priceMin + '~' + priceMax + '元'
        } else if (priceMin && !priceMax) {
          this.priceInteval = '≥' + priceMin + '元'
        } else if (!priceMin && priceMax) {
          this.priceInteval = '≤' + priceMax + '元'
        } else {
          this.priceInteval = ''
        }
        if (start != query.start) {
          query.start = this.$store.state.user.start
        }
        if (end != query.end) {
          query.end = this.$store.state.user.end
        }
        if (url_id) {
          query.url_id = url_id
        }
        if (query.start) {
          this.resetJumpDebounce(query)
        }
      },
    },
    selectIds(newVal, oldVal) {
      let jd_multiple_parent_level4 = false
      if (
        newVal &&
        _.isArray(newVal) &&
        !_.isObject(newVal[0]) &&
        newVal[0] == 1
      ) {
        return false
      }
      if (
        this.plat == 'jd' &&
        _.find(newVal, function (o) {
          return o.cat_id.includes('_')
        })
      ) {
        let newObj = _.forEach(newVal, (item) => {
          if (item.cat_id.includes('_')) {
            item.cat_id = item.cat_id.split('_')[1]
          }
        })
        if (_.isEqual(newObj, oldVal)) {
          jd_multiple_parent_level4 = true
        }
      }
      if (!_.isEqual(newVal, oldVal) && !jd_multiple_parent_level4) {
        this.setStartAndEnd(newVal)
      }
      if (
        _.isEqual(newVal, oldVal) ||
        (oldVal.length == 0 && Object.keys(this.$route.query).length == 0) ||
        jd_multiple_parent_level4
      ) {
        return
      }
      this.$store.dispatch('user/changeMultipleCatIdArr', newVal)
      if (newVal.length == 1) {
        this.defaultCheckedKeys = newVal
        this.childrenCats = []
        if (this.fxUrlId == '') {
          const filterParams = buildSafeFilterParams(
            this.$store.state.user.filterParams,
            this.$route.query
          )
          if (newVal && newVal[0].cat_id) {
            let cat_id = newVal[0].cat_id
            let cats = newVal
            if (this.plat == 'jd' && cat_id.includes('_')) {
              cats = _.forEach(cats, (item) => {
                if (item.cat_id.includes('_')) {
                  item.cat_id = item.cat_id.split('_')[1]
                }
              })
              cat_id = cat_id.split('_')[1]
            }
            filterParams.plat = this.plat
            filterParams.cat_id = cat_id
            filterParams.cats = cats
            filterParams.url_id = cat_id
            filterParams.parent_cat_id = newVal[0].parent_id
            changeUrlId(filterParams).then(() => {
              this.$store.dispatch('user/changeCatId', newVal[0].cat_id)
            })
          }
        } else {
          const filterParams = buildSafeFilterParams(
            this.$store.state.user.filterParams,
            this.$route.query
          )
          changeUrlId(filterParams).then(() => {
            this.$store.dispatch(
              'user/changeCatId',
              filterParams.cat_id ? filterParams.cat_id : this.$route.query.cid
            )
          })
        }
        this.$store.dispatch('user/changeParentCatId', newVal[0].parent_id)
      } else if (newVal.length > 1) {
        this.defaultCheckedKeys = newVal
        let cats = newVal
        if (
          this.plat == 'jd' &&
          _.find(cats, function (o) {
            return o.cat_id.includes('_')
          })
        ) {
          cats = _.forEach(cats, (item) => {
            if (item.cat_id.includes('_')) {
              item.cat_id = item.cat_id.split('_')[1]
            }
          })
        }
        postUrlId({
          plat: this.plat,
          cats: cats,
        }).then((res) => {
          if (res.status == 'ok') {
            const result = res.result
            const url_id = result.data.url_id
            if (this.fxUrlId == '') {
              const filterParams = buildSafeFilterParams(
                this.$store.state.user.filterParams,
                this.$route.query
              )
              filterParams.cat_id = url_id
              filterParams.url_id = url_id
              filterParams.cats = newVal
              changeUrlId(filterParams).then(() => {
                this.$store.dispatch('user/changeCatId', url_id)
              })
            } else {
              const filterParams = buildSafeFilterParams(
                this.$store.state.user.filterParams,
                this.$route.query
              )
              changeUrlId(filterParams).then(() => {
                this.$store.dispatch(
                  'user/changeCatId',
                  filterParams.cat_id
                    ? filterParams.cat_id
                    : this.$route.query.cid
                )
              })
            }
            this.$store.dispatch('user/changeParentCatId', '')
          }
        })
      } else {
        return
      }
    },
    '$route.query': {
      handler(newVal, oldVal) {
        this.getMarked()
        let query = _.cloneDeep(newVal)
        const loginCatlist = this.$store.state.user.loginInfo.cat_list
        let noPermission = false
        if (loginCatlist !== 'all' && query.plat) {
          let cat_list = loginCatlist[query.plat]
          // cat_list 为空，说明该用户没有权限
          let arrs = Object.keys(cat_list).find((v) => cat_list[v].length > 0)
          if (arrs) {
            noPermission = false
          } else {
            noPermission = true
          }
        }
        if (noPermission) {
          this.showCatTree = false
          return
        } else {
          this.showCatTree = true
        }
        const numberRegex = /^\d+$/
        const singleCid = numberRegex.test(query.cid)
        if (this.customCats.length > 0) {
          let customIndex = this.customCats.findIndex((item) => {
            return _.includes(query.cid, item)
          })
          let bl = true
          if (this.plat == 'jd' && newVal && newVal.cid.includes('_')) {
            bl = false
          }
          if (
            !singleCid &&
            customIndex == -1 &&
            newVal.cid != oldVal.cid &&
            bl
          ) {
            getUrlId({ url_id: query.cid }).then((res) => {
              if (res.status == 'ok') {
                const { cats } = res.result.data
                this.childrenCats = []
                cats.forEach((item) => {
                  this.childrenCats.push(item)
                })
                const datas = this.cacheData
                const childrenList = datas
                  ? datas.result.childrenList
                  : undefined
                if (datas && childrenList) {
                  let availableCidList = []
                  // 如果当前选择类目没权限，就给有权限的类目
                  this.childrenCats.forEach((item) => {
                    if (item.cat_id) {
                      let cidIndex = this.cidList.findIndex(
                        (ele) => ele == item.cat_id
                      )
                      if (cidIndex == -1) {
                        let cat_id = item.cat_id
                        if (
                          !childrenList[item.cat_id] &&
                          this.plat == 'jd' &&
                          item.parent_id
                        ) {
                          cat_id = item.parent_id + '_' + item.cat_id //jd四级类目存在特殊情况需单独处理
                        }
                        const parent_id = childrenList[cat_id].parent_id
                        let childIndex = childrenList[parent_id].chd.findIndex(
                          (ele) => ele == cat_id
                        )
                        if (childIndex > -1) {
                          availableCidList.push(cat_id)
                        }
                      } else {
                        availableCidList.push(item.cat_id)
                      }
                    } else {
                      let cidIndex = this.cidList.findIndex(
                        (ele) => ele == item
                      )
                      if (cidIndex == -1) {
                        const parent_id = childrenList[item].parent_id
                        let childIndex = childrenList[parent_id].chd.findIndex(
                          (ele) => ele == item
                        )
                        if (childIndex > -1) {
                          availableCidList.push(item)
                        }
                      } else {
                        availableCidList.push(item)
                      }
                    }
                  })
                  if (availableCidList.length > 0) {
                    this.defaultCheckedKeys = availableCidList
                  } else {
                    this.defaultCheckedKeys = [this.cidList[0]]
                  }
                }
                // this.$store.dispatch('user/changeCatId', query.cid)
                if (this.$store.state.user.ActivedTab != 'AiInterpret') {
                  this.$store.dispatch('user/changeActivedTab', 'Summary')
                }
              }
            })
          } else {
            if (newVal.cid != oldVal.cid) {
              this.defaultCheckedKeys = [query.cid]
              if (this.$store.state.user.ActivedTab != 'AiInterpret') {
                this.$store.dispatch('user/changeActivedTab', 'Summary')
              }
              //   this.$store.dispatch(
              //     'user/changeCatId',
              //     this.defaultCheckedKeys[0]
              //   )
            }
          }
        }
        // if (newVal.plat == 'custom' && newVal.cid != oldVal.cid) {
        //   this.$store.dispatch('user/changeAttrId', '')
        //   this.$store.dispatch('user/changeAttrName', '')
        //   query.attr_id = this.$store.state.user.attrId
        //   query.attr_name = this.$store.state.user.attrName
        //   this.$store.dispatch('user/changeActivedTab', 'Summary')
        //   this.$router.push({
        //     name: this.$route.name,
        //     query,
        //   })
        // }
      },
    },
  },
}
</script>

<style lang="less" scoped>
.fenxi-tooltip {
  .fenxi-tool-content {
    font-size: 14px;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    .fenxi-tool-plat {
      color: #ffffff;
      border: 1px solid;
      background-color: #3a63f3;
      padding: 4px;
      margin-right: 10px;
      margin-bottom: 4px;
    }
    .fenxi-tool-cat {
      color: #ffffff;
      border: 1px solid;
      background-color: #ff6a5b;
      padding: 4px;
      margin-right: 10px;
      margin-bottom: 4px;
    }
    .fenxi-tool-keyword {
      color: #ffffff;
      border: 1px solid;
      background-color: #5bc0de;
      padding: 4px;
      margin-right: 10px;
      margin-bottom: 4px;
      flex: 1;
    }
    .fenxi-tool-avgPrice {
      color: #ffffff;
      border: 1px solid;
      background-color: #427ff0;
      padding: 4px;
      margin-right: 10px;
      margin-bottom: 4px;
    }
    .fenxi-tool-sold {
      color: #ffffff;
      border: 1px solid;
      background-color: #9338e9;
      padding: 4px;
      margin-right: 10px;
      margin-bottom: 4px;
    }
    .fenxi-tool-sales {
      color: #ffffff;
      border: 1px solid;
      background-color: #74d150;
      padding: 4px;
      margin-right: 10px;
      margin-bottom: 4px;
    }
    .fenxi-tool-brand {
      color: #ffffff;
      border: 1px solid;
      background-color: #29b36e;
      padding: 4px;
      margin-right: 10px;
      margin-bottom: 4px;
    }
    .fenxi-tool-shop {
      color: #ffffff;
      border: 1px solid;
      background-color: #5bc0de;
      padding: 4px;
      margin-right: 10px;
      margin-bottom: 4px;
    }
    .fenxi-tool-attr {
      color: #ffffff;
      border: 1px solid;
      background-color: #7baaf1;
      padding: 4px;
      margin-right: 10px;
      margin-bottom: 4px;
    }
    .fenxi-tool-rule {
      color: #ffffff;
      border: 1px solid;
      background-color: #80b436;
      padding: 4px;
      margin-right: 10px;
      margin-bottom: 4px;
    }
    .fenxi-tool-onlineTime {
      color: #ffffff;
      border: 1px solid;
      background-color: #f19f7b;
      padding: 4px;
      margin-right: 10px;
      margin-bottom: 4px;
    }
    .fenxi-tool-filingDate {
      color: #ffffff;
      border: 1px solid;
      background-color: #f19f7b;
      padding: 4px;
      margin-right: 10px;
      margin-bottom: 4px;
    }
    .fenxi-tool-filingName {
      color: #ffffff;
      border: 1px solid;
      background-color: #58a7e6;
      padding: 4px;
      margin-right: 10px;
      margin-bottom: 4px;
    }
    .fenxi-tool-itemIds {
      color: #ffffff;
      border: 1px solid;
      background-color: #cc29b3;
      padding: 4px;
      margin-right: 10px;
      margin-bottom: 4px;
    }
  }
}
.filter-header-cpn {
  width: 100%;
  min-height: 50px;
  margin-bottom: 5px;
  margin-top: 10px;
  padding: 0 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .left-area {
    // float: left;
    display: flex;
    align-items: center;
    overflow: auto hidden;
    flex-wrap: wrap;
    .plat-select-area {
      min-width: 140px;
      height: 40px;
      line-height: 40px;
      margin-right: 10px;
    }

    .cat-select-area {
      height: 40px;
      line-height: 40px;
      display: flex;
    }
    .aspect-tag {
      display: flex;
      align-items: center;
      height: 40px;
      .placehold {
        margin: 0 5px;
      }
      .aspectName {
        text-align: center;
        font-size: 14px;
        font-weight: bold;
        background-color: rgba(72, 219, 192, 0.3);
        border: 1px solid #ffe5cc;
      }
    }

    .tag {
      display: flex;
      align-items: center;
      height: 40px;
      .placehold {
        margin: 0 5px;
      }

      .tagName {
        text-align: center;
        font-size: 14px;
        font-weight: bold;
        background-color: rgba(72, 219, 192, 0.3);
        border: 1px solid #ffe5cc;
      }
    }

    .subscribe-area {
      min-width: 90px;
      height: 40px;
      line-height: 40px;
      margin-left: 10px;
      cursor: pointer;
    }
  }
  .right-area {
    // float: right;
    .question-area {
      float: left;
      height: 40px;
      line-height: 40px;
    }
    .time-picker-area {
      display: flex;
      height: 40px;
      line-height: 40px;
      float: left;
    }
  }
}
.item-select {
  width: 100px;
  /deep/ input {
    height: 30px;
    font-size: 14px;
    color: #333;
    background-color: transparent;
    border-color: transparent !important;
    border-radius: unset;
    padding: 0 5px;
  }
  /deep/ input::-webkit-input-placeholder {
    color: #a4a4a4;
  }
  /deep/ i {
    color: #ffffff;
  }
  /deep/ .el-select-dropdown__list {
    padding: 0;
  }
  /deep/ .popper__arrow {
    display: none;
  }
  /deep/ .el-popper {
    border-radius: 10px;
    margin-top: 0px;
    left: 0px !important;
  }
  /deep/ .el-input__suffix {
    display: none;
  }
  .el-input__inner {
    border-color: transparent;
  }
}

.pictype-select-popper {
  .el-select-dropdown__item {
    font-size: 14px;
    color: #a4a4a4;
    font-weight: normal;
    background-color: #fff;
    padding: 5px 10px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .el-select-dropdown__item.selected {
    font-weight: normal;
    background-color: #f7f7f7;
    color: #ff7d00 !important;
  }
  .el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover {
    color: #a4a4a4;
    font-weight: normal;
    background-color: #f7f7f7;
  }
}
</style>
<style lang="less">
.left-area {
  .plat-select-area {
    .el-select > .el-input {
      width: 100px;
    }
  }
}
</style>
